import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Wrapper = styled.div(() =>
  mq({
    textAlign: 'center',
  }),
);

export const ResultText = styled.p(() =>
  mq({
    marginBottom: defaultTheme.spacing.xxl,
  }),
);
